import React from 'react';
import { SUPPORT_EMAIL, SUPPORT_MAILTO } from '../../data/site';
export function Guarantee() {
  return <section aria-labelledby="guarantee-title" className="bg-forest py-20 text-white lg:py-24" data-id="element-203" data-mp="20ktk5o7r2z1s">
      <div className="mx-auto grid max-w-4xl items-center gap-10 px-5 text-center md:grid-cols-[220px_1fr] md:text-left lg:px-8" data-id="element-204" data-mp="24myc8iijvnmb">
        <svg aria-hidden="true" viewBox="0 0 200 200" className="mx-auto h-48 w-48 md:h-56 md:w-56" data-id="element-205" data-mp="29fhuvtw3h8xz">
          <circle cx="100" cy="100" r="96" fill="#06172B" stroke="#3DD6EE" strokeWidth="4" data-id="element-206" data-mp="2ecrpdnyccaso" />
          <circle cx="100" cy="100" r="82" fill="none" stroke="#3DD6EE" strokeWidth="1.5" strokeDasharray="3 5" data-id="element-207" data-mp="2jajhoj2wdyxe" />
          <text x="100" y="104" textAnchor="middle" fontFamily="'Barlow Condensed', sans-serif" fontWeight="800" fontSize="84" fill="#3DD6EE" data-id="element-208" data-mp="2o9340klelcqa">
            10
          </text>
          <text x="100" y="134" textAnchor="middle" fontFamily="'Barlow Condensed', sans-serif" fontWeight="700" fontSize="22" letterSpacing="3" fill="#FFFFFF" data-id="element-209" data-mp="tyhlf5v9k4t7">
            DAYS
          </text>
          <text x="100" y="156" textAnchor="middle" fontFamily="'DM Sans', sans-serif" fontWeight="700" fontSize="11" letterSpacing="2" fill="#3DD6EE" data-id="element-210" data-mp="3sm87cxbldkru">
            MONEY-BACK
          </text>
        </svg>
        <div data-id="element-211" data-mp="3iwes9mc8qniu">
          <h2 id="guarantee-title" className="font-display text-[40px] font-bold uppercase leading-[0.95] sm:text-[56px]" data-id="element-212" data-mp="3ivwom4n9170w">
            10-Day Money-Back <span className="text-gold" data-id="element-213" data-mp="femwdwuzhjfd">Guarantee</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-white/85 sm:text-lg" data-id="element-214" data-mp="fctxj3qm43hx">
            Review the pack and decide whether it fits your classes. If it isn't right for you, email{' '}
            <a href={SUPPORT_MAILTO} className="font-bold text-gold underline underline-offset-4 hover:text-white" data-id="element-215" data-mp="5ew4m2xt5iiz">
              {SUPPORT_EMAIL}
            </a>{' '}
            within 10 days of purchase to request a refund.
          </p>
        </div>
      </div>
    </section>;
}